// extracted by mini-css-extract-plugin
module.exports =  {"destructive_border":"MessageDestructive-module__destructive_border___y7oPw"};